<div class="input-group mr-2" *ngIf ="this.input_change">
    <input  
    class="form-control" 
    [ngModel]="dateString | date:inputDatetimeFormat" 
    (change)="onInputChange($event);input_change_timeout()" 
    [dropSpecialCharacters]="false" 
    mask="{{mask}}" 
    [showMaskTyped] = "true"
    (keyup)="onInputKeyup($event)"
    
    />

    <div class="input-group-append date-icon-box">
        <button class="btn date-icon" [ngbPopover]="calendarContent" [placement]="placement" [disabled]="disabled" type="button" (click) = openpopup()>
        </button>
    </div>
</div>

<ng-template #calendarContent>
    <div class="dp-popup-header">
        <span *ngIf="!no_time">{{header_lang}}</span>
        <span *ngIf="no_time">{{header_no_time_lang}}</span>
    </div>
    <div>
        <ngb-datepicker #dp 
            name="datepicker" 
            [ngModel]="datetime" 
            (ngModelChange)="onDateChange($event, dp)"
            [maxDate]="configDate.maxDate"
            [minDate]="configDate.minDate"
            [startDate]="datetime"
        ></ngb-datepicker>

        <ng-container *ngIf="!no_time">        
            <div class="dp-popup-timeheader clearfix">
                <span>{{hours_lang}}</span>
                <span>{{minutes_lang}}</span>
                <span>{{seconds_lang}}</span>
            </div>
            <ngb-timepicker #tp 
                [disabled]="!checkDT()" 
                name="timepicker" 
                [ngModel]="datetime" 
                (ngModelChange)="onTimeChange($event)" 
                [seconds]="seconds"
                [hourStep]="hourStep" 
                [minuteStep]="minuteStep" 
                [secondStep]="secondStep">
            </ngb-timepicker>
        
        </ng-container>
    </div>
</ng-template>